module.exports = __webpack_public_path__ + "static/media/presentation_3.894f5baa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neonat/icons/presentation_3.svg
// module id = 631
// module chunks = 1